import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import NotFound from '@/views/NotFound.vue'
const EcoTabsComponent = () => import('@/components/common/FeTabsComponent.vue')
const TemplateComponent = () => import('@/components/common/FeTemplateComponent.vue')

Vue.use(Router)

var router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/login/:tenant?',
      name: 'tenantLogin',
      component: () => import('@/views/Login.vue'),
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: '/resetPwdView',
      name: 'resetPwdView',
      props: true,
      component: () => import('@/views/ResetPwdView.vue'),
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/href/template/:alias',
      name: 'href',
      component: () => import('@/components/common/FeTabsComponentHref.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/common/Home.vue'),
      meta: {
        isHome: true
      }
    },
    {
      path: '/form',
      name: 'form',
      component: EcoTabsComponent
    },
    {
      path: '/formPermission',
      name: 'formPermission',
      component: EcoTabsComponent
    },
    {
      path: '/report',
      name: 'report',
      component: EcoTabsComponent
    },
    {
      path: '/meta',
      name: 'meta',
      component: EcoTabsComponent
    },
    {
      path: '/i18n',
      name: 'i18n',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/reportLine',
      name: 'reportLine',
      component: EcoTabsComponent
    },
    {
      path: '/roleManager',
      name: 'roleManager',
      component: EcoTabsComponent
    },
    {
      path: '/menuManagerRouter',
      name: 'menuManagerRouter',
      component: EcoTabsComponent
    },
    {
      path: '/ucManager',
      name: 'ucManager',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/accountManagement',
      name: 'accountManagement',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/tenantType',
      name: 'tenantType',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/tenant',
      name: 'tenant',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/tenantMailServer',
      name: 'tenantMailServer',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/tenantManager',
      name: 'tenantManager',
      component: EcoTabsComponent
    },
    {
      path: '/tenantFlowConfigManager',
      name: 'tenantFlowConfigManager',
      component: EcoTabsComponent
    },
    {
      path: '/ruleConfigManager',
      name: 'ruleConfigManager',
      component: EcoTabsComponent
    },
    {
      path: '/tenantInfoManager',
      name: 'tenantInfoManager',
      component: EcoTabsComponent
    },
    {
      path: '/documentManagement',
      name: 'documentManagement',
      component: EcoTabsComponent
    },
    {
      path: '/init_data',
      name: 'init_data',
      component: EcoTabsComponent
    },
    {
      path: '/instance',
      name: 'instance',
      component: EcoTabsComponent
    },
    {
      path: '/customDialogList',
      name: 'customDialogList',
      component: EcoTabsComponent
    },
    {
      path: '/customQueryList',
      name: 'customQueryList',
      component: EcoTabsComponent
    },
    {
      path: '/fileList',
      name: 'fileList',
      component: EcoTabsComponent
    },
    {
      path: '/flowDesign',
      name: 'flowDesign',
      component: EcoTabsComponent
    },
    {
      path: '/flowRouter',
      name: 'flowRouter',
      component: EcoTabsComponent
    },
    {
      path: '/organization',
      name: 'organization',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/businessObj',
      name: 'businessObj',
      component: EcoTabsComponent
    },
    {
      path: '/sysTypeManager',
      name: 'sysTypeManager',
      component: EcoTabsComponent,
      meta: {
        isReloadPage: true
      }
    },
    {
      path: '/schedulerManager',
      name: 'schedulerManager',
      component: EcoTabsComponent
    },
    {
      path: '/customChartManager',
      name: 'customChartManager',
      component: EcoTabsComponent
    },
    {
      path: '/reportManager',
      name: 'reportManager',
      component: EcoTabsComponent
    },
    {
      path: '/heiOrganization',
      name: 'heiOrganization',
      component: EcoTabsComponent
    },
    {
      path: '/reportManager/viewList',
      name: 'viewList',
      component: () => import('@/components/form/customView/ViewList.vue'),
      meta: {
        isHome: true
      }
    },
    {
      path: '/reportManager/flowChartEdit',
      name: 'flowChartEdit',
      component: () => import('@/components/form/chart/FlowChartEdit.vue'),
      meta: {
        isHome: true
      }
    },
    {
      path: '/htmbManageList',
      name: 'htmbManageList',
      component: EcoTabsComponent
    },
    {
      path: '/constructionProcedureTemplate',
      name: 'constructionProcedureTemplate',
      component: EcoTabsComponent
    },
    {
      path: '/managementPlanTemplate',
      name: 'managementPlanTemplate',
      component: EcoTabsComponent
    },
    {
      path: '/marketTaskTemplate',
      name: 'marketTaskTemplate',
      component: EcoTabsComponent
    },

    {
      path: '/costAccountTemplate',
      name: 'costAccountTemplate',
      component: EcoTabsComponent
    },
    {
      path: '/oaTaskTemplate',
      name: 'oaTaskTemplate',
      component: EcoTabsComponent
    },
    {
      path: '/approvalReportTemplate',
      name: 'approvalReportTemplate',
      component: EcoTabsComponent
    },
    {
      path: '/agent',
      name: 'agent',
      component: EcoTabsComponent
    },
    {
      path: '/formTemplateList',
      name: 'formTemplateList',
      component: EcoTabsComponent
    },
    {
      path: '/dataTemplateList',
      name: 'dataTemplateList',
      component: EcoTabsComponent
    },
    {
      path: '/executeJobList/:jobName',
      name: 'executeJobList',
      component: EcoTabsComponent,
      meta: {
        keepAlive: true //页面跳转重新渲染 默认不渲染
      }
    },
    {
      path: '/schedulerTriggerList/:jobName',
      name: 'schedulerTriggerList',
      component: EcoTabsComponent,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/portal',
      name: 'portal',
      component: EcoTabsComponent
    },
    {
      path: '/sysPropertiesManager',
      name: 'sysPropertiesManager',
      component: EcoTabsComponent
    },
    //系统公告
    {
      path: '/system_notice',
      name: 'system_notice',
      component: EcoTabsComponent
    },
    //需求反馈
    {
      path: '/demandFeedback',
      name: 'demandFeedback',
      component: EcoTabsComponent
    },
    {
      path: '/sysExternalUniteList',
      name: 'sysExternalUniteList',
      component: () => import('@/views/system/sysExternalUnite/SysExternalUnite.vue')
    },
    {
      path: '/sysModuleList',
      name: 'sysModuleList',
      component: () => import('@/views/system/generator/sysModuleList.vue')
    },

    {
      path: '/help',
      name: 'help',
      component: EcoTabsComponent
    },
    {
      path: '/systemLog',
      name: 'systemLog',
      component: EcoTabsComponent
    },
    {
      path: '/templateMenu/:alias',
      name: 'templateMenu',
      component: TemplateComponent,
      meta: {
        keepAlive: true //页面跳转重新渲染 默认不渲染
      }
    },
    {
      path: '/pwdStrategy',
      name: 'pwdStrategy',
      component: EcoTabsComponent
    },
    {
      path: '/codeGenerator',
      name: 'codeGenerator',
      component: EcoTabsComponent
    },
    {
      path: '/financeExternal',
      name: 'financeExternal',
      component: EcoTabsComponent
    },
    // 计费中心
    // 计费中心内页
    {
      path: '/billing_center_inner',
      name: 'billing_center_inner',
      component: EcoTabsComponent
    },
    //订单管理
    {
      path: '/order_management',
      name: 'order_management',
      component: EcoTabsComponent
    },
    //付款记录
    {
      path: '/payment_record',
      name: 'payment_record',
      component: EcoTabsComponent
    },
    //开票记录
    {
      path: '/invoice_record',
      name: 'invoice_record',
      component: EcoTabsComponent
    },
    //  套餐中心  package_center
    {
      path: '/package_center',
      name: 'package_center',
      component: EcoTabsComponent
    },
    //  维护中心
    {
      path: '/maintain_center',
      name: 'maintain_center',
      component: EcoTabsComponent
    },
    //  套餐中心  package_center
    {
      path: '/billingCenterCommon',
      name: 'billingCenterCommon',
      component: EcoTabsComponent
    },
    //  费用科目规则  OCR_expense_account
    {
      path: '/OCR_expense_account',
      name: 'OCR_expense_account',
      component: EcoTabsComponent
    },
    //字段规则
    {
      path: '/field_rules',
      name: 'field_rules',
      component: EcoTabsComponent
    },
    //提醒规则
    {
      path: '/noticeRules',
      name: 'noticeRules',
      component: EcoTabsComponent
    },
    //提醒规则
    {
      path: '/systemAttribute',
      name: 'systemAttribute',
      component: EcoTabsComponent
    },
    //自定义名称
    {
      path: '/customField',
      name: 'customField',
      component: EcoTabsComponent
    },
    //提醒规则
    {
      path: '/businessRulesSwitch',
      name: 'businessRulesSwitch',
      component: EcoTabsComponent
    },
    //表单权限
    {
      path: '/bdqx',
      name: 'bdqx',
      component: EcoTabsComponent
    },
    // 计费中心
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        single: true
      }
    },
    // 表单扩展字段
    {
      path: '/formExpandManage',
      name: 'formExpandManage',
      component: EcoTabsComponent
    },
    //水印设置
    {
      path: '/watermarkTemplate',
      name: 'watermarkTemplate',
      component: EcoTabsComponent
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.anonymous)) {
    let ticket = to.query.ticket
    if (ticket) {
      let account = to.query.account
      let tenantId = to.query.tenantId
      sessionStorage.setItem('tenantManager', 'true')
      store.dispatch('tenant/actionTenantId', tenantId)
      store.dispatch('tenant/actionCurrentTenantId', tenantId)
      store
        .dispatch('login/loginByPrincipal', {
          ticket: ticket,
          grant_type: 'ticket',
          account_type: 'evo'
        })
        .then((loginStatus) => {
          if (loginStatus) {
            store.dispatch('login/setCurUser', account).then(() => {
              store.dispatch('user/loadCurrentUserDetail').then(() => {
                // 获取下老系统jwt
                store.dispatch('login/loginV2Token', account)
                store.dispatch('login/actionLoginAccount', account)
                store.dispatch('menu/actionMenus').then(() => {
                  next({
                    name: 'home'
                  })
                })
              })
            })
          }
        })
        .catch((msg) => {
          console.error(msg)
        })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
